import $ from 'jquery';

// Elements with the ALL selector will automatically have dropdown search functionality attached.
const ALL = '.dropdown-menu.dropdown-menu-search';
const SELECTOR_VISIBLE_ITEMS = '.dropdown-menu.dropdown-menu-search .dropdown-item:not(.disabled):not(:disabled)';
const FILTERABLE_DROPDOWN_MENU = '[data-toggle="filterable-dropdown-menu"]'

const DROPDOWN_ITEM_GROUP = '.dropdown-item-group';
const DROPDOWN_HEADER = '.dropdown-header';
const DROPDOWN_SEARCH_INPUT = '.dropdown-search input';
const ENABLED_DROPDOWN_ITEMS = '.dropdown-item:not(.disabled)';
const DISPLAYED_DROPDOWN_ITEMS = '.dropdown-item.d-none:not(.disabled)';

const REMOVE_ICON = '.remove-icon';
const NO_RESULTS_FOUND = '.dropdown-item.disabled.no-results-found';

const ARROW_UP_KEYCODE = 38;
const ARROW_DOWN_KEYCODE = 40;

const focusSearchResults = (items) => {
  if (items.length === 0) { return }

  items[0].focus();
}

const focusSearchInput = (items) => {
  if (items.length === 0) { return }

  items[0].addEventListener('keydown', event => {
    if (event.isComposing || event.which !== ARROW_UP_KEYCODE) { return }

    const searchInput = event.target.closest(ALL).querySelector('input');
    // plain ol' .select() doesn't seem to work here, so we need to wrap it in
    // a setTimeout
    setTimeout(() => { searchInput.select() }, 10);
  })
}

// Adds focus and key down functionality to the search dropdown items
const searchDropdownInit = (dropdown) => {
  if (!dropdown.querySelector(DROPDOWN_SEARCH_INPUT)) { return }

  // Focus the search input when dropdown opens
  $(dropdown.parentNode).on('shown.bs.dropdown', (event) => {
    const searchInput = 'input:not([data-toggle="dropdown"])';
    event.target.querySelector(searchInput).select();
  })

  // Focus the search results when the down key is pressed
  dropdown.querySelector('input').addEventListener('keydown', event => {
    if (event.isComposing || event.which !== ARROW_DOWN_KEYCODE) { return }

    event.preventDefault();
    const searchItems = [].slice.call(dropdown.querySelectorAll(SELECTOR_VISIBLE_ITEMS))
      .filter((item) => $(item).is(':visible'));
    focusSearchResults(searchItems);
    focusSearchInput(searchItems);
  });

  // When the clear input button is clicked, clear and focus the search input
  const clearInput = dropdown.querySelector(REMOVE_ICON)
  clearInput.addEventListener('click', function(event){
    event.stopPropagation();
    var searchInput = event.target.closest('.dropdown-search').querySelector('input');
    searchInput.value = '';
    searchInput.dispatchEvent(new Event('input'));
    searchInput.focus();
  })
}

// Adds client side filtering/search functionality to the dropdown
const searchDropdownMenuInit = (dropdownMenu) => {
  if (!dropdownMenu.querySelector(DROPDOWN_SEARCH_INPUT)) { return }

  dropdownMenu.querySelector(DROPDOWN_SEARCH_INPUT).addEventListener('input', event => {
    const searchQuery = event.target.value.trim().toLowerCase();

    // Hide headers when searching
    const headers = dropdownMenu.querySelectorAll(DROPDOWN_HEADER);
    if (searchQuery !== '') {
      headers.forEach(header => header.classList.add('d-none'));
    } else {
      headers.forEach(header => header.classList.remove('d-none'));
    }

    // Hide unmatching dropdown items with the search query
    const allDropdownItems = dropdownMenu.querySelectorAll(ENABLED_DROPDOWN_ITEMS)
    allDropdownItems.forEach(item => {
      const dropdownItemText = item.innerHTML.toLowerCase()
      if (dropdownItemText.includes(searchQuery)) {
        item.classList.remove('d-none');
      } else {
        item.classList.add('d-none');
      }
    })

    // Reset "no results found" before checking to see if
    const noResultsFoundEl = dropdownMenu.querySelector(NO_RESULTS_FOUND)
    if (noResultsFoundEl) {
      noResultsFoundEl.remove();
    }

    // Show no results found when no dropdown items are present
    if (allDropdownItems.length == dropdownMenu.querySelectorAll(DISPLAYED_DROPDOWN_ITEMS).length) {
      const noResultsFound = document.createElement('a');
      noResultsFound.setAttribute('href', '#');
      noResultsFound.innerText = 'No results found';
      noResultsFound.classList.add('dropdown-item', 'disabled', 'no-results-found');
      dropdownMenu.querySelector(DROPDOWN_ITEM_GROUP).appendChild(noResultsFound);
    }
  });
}

// Expose a simple function for selecting all dropdowns with search currently present in the DOM,
const attachAll = () => {
  document.querySelectorAll(ALL).forEach((dropdown) => {
    searchDropdownInit(dropdown);
  });

  document.querySelectorAll(FILTERABLE_DROPDOWN_MENU).forEach((dropdownMenu) => {
    searchDropdownMenuInit(dropdownMenu);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.filter((m) => m.addedNodes.length > 0).forEach((mutation) => {
      // Observe mutations on elements that include a dropdown
      mutation.target.querySelectorAll(ALL).forEach((dropdown) => {
        searchDropdownInit(dropdown);
      })
      mutation.target.querySelectorAll(FILTERABLE_DROPDOWN_MENU).forEach((dropdownMenu) => {
        searchDropdownMenuInit(dropdownMenu);
      })

      // Observe mutations directly on dropdowns
      if (mutation.target.matches(ALL)) {
        searchDropdownInit(mutation.target);
      }
      if (mutation.target.matches(FILTERABLE_DROPDOWN_MENU)) {
        searchDropdownMenuInit(mutation.target);
      }
    })
  })

  observer.observe(document.body, { childList: true, subtree: true });
}

export default { attachAll }
